import React from "react";
import { Outlet } from "react-router-dom";
import { Box, useMediaQuery, useTheme } from "@mui/material";

import Header from "./Header";
import Sidebar, { DRAWER_WIDTH } from "./Sidebar";
import { LegalFooter } from "./LegalFooter";
import { useAppSelector } from "../../store";

const AppLayout: React.FC = () => {
  const { sidebarOpen } = useAppSelector((state) => state.ui);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          transition: (theme) =>
            theme.transitions.create("margin", {
              easing: sidebarOpen
                ? theme.transitions.easing.easeOut
                : theme.transitions.easing.sharp,
              duration: sidebarOpen
                ? theme.transitions.duration.enteringScreen
                : theme.transitions.duration.leavingScreen,
            }),
          ml: isMobile ? 0 : sidebarOpen ? 0 : `-${DRAWER_WIDTH}px`,
          bgcolor: "background.default",
          minHeight: "100vh",
        }}
      >
        <Header />
        <Box sx={{ flex: 1, overflow: "auto", p: { xs: 2, md: 4 } }}>
          <Outlet />
        </Box>
        <LegalFooter />
      </Box>
    </Box>
  );
};

export default AppLayout;
